import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingBar from "@/components/FloatingBar";

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen bg-sand-50 font-sans text-moss-900 antialiased">
            <div className="noise-overlay" />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <About />
                <Booking />
                <Contact />
            </main>
            <Footer />
            <FloatingBar />
            <Toaster position="top-center" richColors />
        </div>
    );
}
